import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const GmailIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22.97 8.05004C22.99 11.63 22.96 15.22 22.97 18.8C22.97 19.56 22.43 20.23 21.72 20.23H17.96V11.74L22.98 8.04004L22.97 8.05004Z",
                fill: "#35A854"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.99001 11.75V20.24H2.23001C1.60001 20.24 1.01001 19.68 1.01001 19.02V8.03003L6.00001 11.76L5.99001 11.75Z",
                fill: "#4284F3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.99 5.29001V11.75L1 8.02001V5.89001C1 5.62001 1.11 5.14001 1.28 4.91001C1.86 4.12001 2.77 3.62001 3.73 3.82001C4.46 3.97001 5.37 4.83001 5.98 5.28001L5.99 5.29001Z",
                fill: "#C4221F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.95 5.29004V11.78L11.95 16.22L5.97998 11.78V5.29004C7.97998 6.77004 9.96998 8.27004 11.97 9.75004C13.98 8.28004 15.95 6.77004 17.94 5.29004H17.95Z",
                fill: "#E94335"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22.97 8.05001L17.95 11.75V5.29001C19.13 4.41001 20.28 3.16001 21.86 4.10001C23.28 4.94001 22.97 6.48001 22.96 8.06001L22.97 8.05001Z",
                fill: "#FABB05"
            })
        ]
    });
};
